<template lang="pug">
  footer(:class="{collapsed: collapsed}")
    span
      | Desenvolvido por
      a(href='http://paliari.com.br' target='_blank') &nbsp;Paliari Engenharia de Software&nbsp;
      | © {{fullYear}}&nbsp;
    code
      small (v{{version}})
</template>

<script>
import { version } from '../../package'

export default {
  props: { collapsed: Boolean },
  data() {
    return {
      version,
    }
  },

  computed: {
    fullYear() {
      return new Date().getFullYear()
    },
  },
}
</script>

<style lang="stylus" scoped>
footer
  text-align right
  padding 5px
  color #999
  font-size .6rem
  background-color #fff
</style>
